// https://owlcarousel2.github.io/OwlCarousel2/demos/demos.html
$('document').ready(function () {
  $('.carousel-default').owlCarousel({
    loop: true,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplaySpeed: 1000,
    autoplayHoverPause: false,
    margin: 20,
    nav: false,
    dots: false,
    responsive: {
      0: {
        items: 1,
        stagePadding: 50,
      },
      576: {
        items: 1,
        stagePadding: 120,
      },
      992: {
        items: 2,
        stagePadding: 140,
      },
      2000: {
        items: 3,
        stagePadding: 200,
      }
    }
  });

  var industries_parent = $('body').hasClass('parent-pageid-1385') || $('body').hasClass('parent-pageid-543');

  $('.carousel-brands').owlCarousel({
    loop: false,
    rewind: true,
    autoplay: false,
    autoplayTimeout: 3000,
    autoplaySpeed: 1000,
    mouseDrag: false,
    pullDrag: false,
    freeDrag: false,
    autoplayHoverPause: false,
    margin: 0,
    nav: true,
    dots: true,
    onDragged: brandsCallback,
    onInitialized: brandsCallback,
    onTranslated: brandsCallback,
    responsive: {
      0: {
        items: industries_parent ? 2 : 1,  // Show 2 items if page has .parent-pageid-1385, else 1 item
      },
      540: {
        items: industries_parent ? 5 : 3,  // Show 5 items if page has .parent-pageid-1385, else 3 items
      },
    }
  });

  $('.flex-slides').owlCarousel({
    loop: true,
    //rtl: true,
    items: 1,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplaySpeed: 1250,
    autoplayHoverPause: true,
    margin: 0,
    nav: false,
    autoheight: true,
    dots: true
  });

  $('.carousel-images').owlCarousel({
    loop: true,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplaySpeed: 1000,
    autoplayHoverPause: true,
    margin: 20,
    nav: false,
    dots: true,
    responsive: {
      0: {
        items: 1,
      },
      540: {
        items: 2,
      },
      960: {
        items: 3,
      },
    }
  });

  $('.carousel-team').owlCarousel({
    loop: false,
    autoplay: false,
    autoplayTimeout: 3000,
    autoplaySpeed: 1000,
    autoplayHoverPause: true,
    margin: 80,
    nav: false,
    dots: true,
    responsive: {
      0: {
        items: 1,
      },
      780: {
        items: 2,
      },
      /*960: {
        items: 3,
      },*/
    }
  });

  $('.carousel-features').owlCarousel({
    loop: false,
    autoplay: false,
    autoplayTimeout: 3000,
    autoplaySpeed: 1000,
    autoplayHoverPause: false,
    margin: 40,
    nav: true,
    center: false,
    dots: false,
    responsive: {
      0: {
        items: 1,
      },
      540: {
        items: 1,
      },
    }
  });

  let carouselPlans = $('.carousel-plans').owlCarousel({
    loop: false,
    autoplay: false,
    margin: 12,
    autoHeight: true,
    nav: true,
    responsive: {
      0: {
        items: 1,
        stagePadding: 0,
        autoHeight: true,
        // dots: true,
        dotsData: true,
        // dotsEach: false,
        dotsContainer: '#customPlanDots',
      },
      960: {
        dotsData: false,
        dotsContainer: false,
        items: 4,
        stagePadding: 0,
        mouseDrag: false,
        touchDrag: false,
      },
    }
  });

  // $('.carousel-plans .accordion-button').on('click', () => {
  //   $('.carousel-plans').trigger('refresh.owl.carousel');
  // });

  $('.owl-dot').on('click', function () {
    carouselPlans.trigger('to.owl.carousel', [$(this).index(), 300]);
    // $('.owl-dot').removeClass('active');
    // $(this).addClass('active');

  });

  $('.carousel-resources').owlCarousel({
    loop: false,
    autoplay: false,
    margin: 24,
    nav: false,
    dots: true,
    responsive: {
      0: {
        items: 1,
        dots: true,
      },
      540: {
        items: 2,
        dots: false,
      },
      960: {
        items: 3,
        dots: false,
      },
    }
  });


  /*
  $(document).on('click', '.carousel-brands .owl-item', function () {
    owlIndex = $(this).index();
    count = document.querySelectorAll(".carousel-brands .owl-item.active").length;
    $('.carousel-brands .owl-stage-outer').trigger('to.owl.carousel', owlIndex - count + 1);
    var description = $(this).find('.brand-description').html();
    $('.brand-description-below').empty().html(description);
  });
  */

  brandsCallback();

  function brandsCallback(event) {

    setTimeout(function () {
      var description = $('.carousel-brands .owl-item.center.active').find('.brand-description').html();
      $('.brand-description-below').empty().html(description);
    }, 200);
  }

});